var _path, _path2, _path3, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavbar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 26.1607C7.68534 26.127 5.49015 25.9059 4.04253 24.4583C2.33398 22.7497 2.33398 19.9999 2.33398 14.5002C2.33398 9.00044 2.33398 6.25058 4.04253 4.54204C5.75107 2.8335 8.50093 2.8335 14.0007 2.8335C19.5004 2.8335 22.2502 2.8335 23.9588 4.54204C25.0948 5.67807 25.4755 7.27447 25.603 9.8335",
    stroke: "#878B92",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91602 8.9585C2.43277 8.9585 2.04102 9.35025 2.04102 9.8335C2.04102 10.3167 2.43277 10.7085 2.91602 10.7085V8.9585ZM25.666 8.9585H2.91602V10.7085H25.666V8.9585Z",
    fill: "#878B92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6551 16.7578L22.1417 16.2712C22.9479 15.4649 24.2551 15.4649 25.0613 16.2712C25.8676 17.0774 25.8676 18.3846 25.0613 19.1909L24.5747 19.6775M21.6551 16.7578C21.6551 16.7578 21.7159 17.7918 22.6283 18.7042C23.5407 19.6166 24.5747 19.6775 24.5747 19.6775M21.6551 16.7578L17.1814 21.2315C16.8784 21.5345 16.7269 21.686 16.5966 21.853C16.4429 22.0501 16.3111 22.2633 16.2036 22.4889C16.1125 22.6801 16.0447 22.8834 15.9092 23.2899L15.4753 24.5915L15.335 25.0126M24.5747 19.6775L20.1011 24.1511C19.7981 24.4541 19.6466 24.6056 19.4795 24.7359C19.2824 24.8896 19.0692 25.0214 18.8436 25.1289C18.6524 25.2201 18.4491 25.2878 18.0426 25.4233L16.741 25.8572L16.3199 25.9976M16.3199 25.9976L15.8988 26.1379C15.6988 26.2046 15.4782 26.1525 15.3291 26.0034C15.18 25.8543 15.1279 25.6337 15.1946 25.4337L15.335 25.0126M16.3199 25.9976L15.335 25.0126",
    stroke: "#878B92",
    strokeWidth: 1.75
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 5.54736,
    width: 3.5,
    height: 1.67096,
    rx: 0.83548,
    fill: "#878B92"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7305,
    y: 5.54736,
    width: 3.5,
    height: 1.67096,
    rx: 0.83548,
    fill: "#878B92"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1172,
    y: 5.54736,
    width: 3.5,
    height: 1.67096,
    rx: 0.83548,
    fill: "#878B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbar);
export default __webpack_public_path__ + "static/media/navbar.ae24df55a06fb14126f23b86b614a27e.svg";
export { ForwardRef as ReactComponent };